// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clientdashboard-list-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  gap: 12px;
  color: white;
}

.clientdashboard-avatar-small {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #eee;
  color: rgb(54, 23, 54);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
}

.clientdashboard-info {
  flex: 1 1;
}

.clientdashboard-name {
  font-weight: bold;
  font-size: 1.1em;
}

.clientdashboard-program {
  color: #666;
  margin-bottom: 4px;
}

.clientdashboard-join-date {
  margin-left: 12px;
  color: #888;
  font-size: 13px;
}

.clientdashboard-row:hover {
  background-color: rgba(0, 0, 0, 0.2);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/ClientsList.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd","sourcesContent":[".clientdashboard-list-item {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: white;\n}\n\n.clientdashboard-avatar-small {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: #eee;\n  color: rgb(54, 23, 54);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 18px;\n}\n\n.clientdashboard-info {\n  flex: 1;\n}\n\n.clientdashboard-name {\n  font-weight: bold;\n  font-size: 1.1em;\n}\n\n.clientdashboard-program {\n  color: #666;\n  margin-bottom: 4px;\n}\n\n.clientdashboard-join-date {\n  margin-left: 12px;\n  color: #888;\n  font-size: 13px;\n}\n\n.clientdashboard-row:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
